// extracted by mini-css-extract-plugin
export default {"termsForm":"TC_termsForm__O3w86","checkboxes":"TC_checkboxes__T-bat"};